import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  QBodyLayout,
  QButtonGroup,
  QHeader,
  QRouteTabs,
  QStack,
  QText,
  QTitle,
} from '@qualio/ui-components';

import { ExportButtonWrapper } from './ExportButtonWrapper';
import { NewDocumentButtonWrapper } from './NewDocumentButtonWrapper';
import { WorkspaceTabsContextWrapper } from './WorkspaceTabsContextWrapper';

export enum WorkspaceTabs {
  YOUR_DOCUMENTS = 'your-documents',
  YOUR_ACTIONS = 'your-actions',
  ALL_DOCUMENTS = 'all-documents',
}

export const WorkspaceV2: React.FC = () => {
  return (
    <WorkspaceTabsContextWrapper>
      <QBodyLayout.Default>
        <Header />
        <WorkspaceWithTabs />
      </QBodyLayout.Default>
    </WorkspaceTabsContextWrapper>
  );
};

const WorkspaceWithTabs = () => {
  const { t } = useTranslation();

  const WORKSPACE_TABS = [
    {
      title: t('labels.yourDocuments'),
      path: `/${WorkspaceTabs.YOUR_DOCUMENTS}`,
      dataCy: 'your-docs-tab',
    },
    {
      title: t('labels.yourActions'),
      path: `/${WorkspaceTabs.YOUR_ACTIONS}`,
      dataCy: 'your-actions-tab',
    },
    {
      title: t('labels.allDocuments'),
      path: `/${WorkspaceTabs.ALL_DOCUMENTS}`,
      dataCy: 'all-docs-tab',
    },
  ] as const;

  return (
    <QRouteTabs>
      {WORKSPACE_TABS.map((tab) => (
        <QRouteTabs.Item
          route={`.${tab.path}`}
          key={tab.path}
          data-cy={tab.dataCy}
        >
          <QStack direction="row" alignItems="center">
            <QText>{tab.title}</QText>
          </QStack>
        </QRouteTabs.Item>
      ))}
    </QRouteTabs>
  );
};

const Header: React.FC = () => {
  const { t } = useTranslation();

  return (
    <QStack>
      <QHeader showDivider={false}>
        <QTitle data-cy="workspace-header">{t('forms.workspace')}</QTitle>
        <QButtonGroup>
          <ExportButtonWrapper />
          <NewDocumentButtonWrapper />
        </QButtonGroup>
      </QHeader>
    </QStack>
  );
};
